import React, { useEffect, useRef, useState } from 'react'
import './eval-data-view.styles.scss'
import { useNavigate, useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { getQueryFromFirestore, getUniqueDocumentFromFirestore } from '../../../utils/getDataFromDbSimplified';
import { ModalAlert } from '../../SHARED/modal/modal.component';
import EvalResultsDisplay from './eval-results-display.component';
import { useSelector } from 'react-redux';

function toDateString(d) {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

const defaultStart = (() => {
  const d = new Date();
  d.setDate(d.getDate() - 10);
  return toDateString(d);
})();

const defaultEnd = toDateString(new Date());

const EvalDataView = ({ evalList}) => {

  const screenSize = useSelector(state => state.listsData.screenSize);
  const { evalPath } = useParams();
  const [evaluationData, setEvaluationData] = useState(null);
  const [userEvaluations, setUserEvaluations] = useState(null);
  const [questionSets, setQuestionSets] = useState(null);
  const [startDate, setStartDate] = useState(defaultStart);
  const [endDate, setEndDate] = useState(defaultEnd);
  const [alertMessage, setAlertMessage] = useState(null);
  const evalIdRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (!evalPath) {
      navigate('/404');
      return;
    }
    getEvalData();
  }, [evalPath])

  function getEvalData() {
    getQueryFromFirestore({
      'path': 'evaluations_v2',
      'queryArray': [
        { 'field': 'path', 'operator': '==', 'value': evalPath }
      ],
      'once': true,
      'callback': callback
    });

    function callback(data) {
      const evalDoc = Object.values(data)[0];
      if (!evalDoc) {
        navigate('/404');
        return;
      }
      setEvaluationData(evalDoc);
      evalIdRef.current = evalDoc.id;
      getQuestionSets(evalDoc);
      getEvaluations(evalDoc.id);
    }
  }

  function getQuestionSets(evalData) {
    if (!evalData.questionSets || evalData.questionSets.length === 0) {
      setAlertMessage('No question sets associated with this evaluation.');
      return;
    }
    const qSets = new Array(evalData.questionSets.length);
    let count = 0;
    evalData.questionSets.forEach((qSetId, index) => {
      getUniqueDocumentFromFirestore({
        'path': `forms_data/${qSetId}`,
        'once': true,
        'callback': (data) => {
          qSets[index] = data;
          count++;
          if (count === evalData.questionSets.length) {
            setQuestionSets(qSets.filter(Boolean));
          }
        }
      });
    });
  }

  function getEvaluations(evalId) {
    const [sy, sm, sd] = startDate.split('-').map(Number);
    const [ey, em, ed] = endDate.split('-').map(Number);
    const startTs = new Date(sy, sm - 1, sd, 0, 0, 0, 0).getTime();
    const endTs = new Date(ey, em - 1, ed, 23, 59, 59, 999).getTime();

    getQueryFromFirestore({
      'path': 'userEvaluations',
      'queryArray': [
        { 'field': 'evalId', 'operator': '==', 'value': evalId },
        { 'field': 'ts', 'operator': '>=', 'value': startTs },
        { 'field': 'ts', 'operator': '<=', 'value': endTs },
      ],
      'once': true,
      'callback': (data) => setUserEvaluations(data)
    });
  }

  function handleGetEvaluations() {
    if (!evalIdRef.current) return;
    setUserEvaluations(null);
    getEvaluations(evalIdRef.current);
  }

  return (
    <div className='eval-data-container'>
      <div className='eval-data-content g-card'>
        <button
          className='g-button small-btn'
          onClick={() => navigate(-1)}>
          <FontAwesomeIcon icon={faArrowLeft} />
          Back
        </button>
        <div className="g-space-1"></div>
        <hr />
        <div className={`date-filter-row ${screenSize}`}>
          <div className='date-filter-field'>
            <label>Start Date</label>
            <input
              type='date'
              className='uk-input'
              value={startDate}
              onChange={e => setStartDate(e.target.value)} />
          </div>
          <div className='date-filter-field'>
            <label>End Date</label>
            <input
              type='date'
              className='uk-input'
              value={endDate}
              onChange={e => setEndDate(e.target.value)} />
          </div>
          <button
            className='g-button med-btn'
            onClick={handleGetEvaluations}>
            Get Evaluations
          </button>
        </div>
        <div className="g-space-1"></div>
        {
          (questionSets && userEvaluations)
            ?
            <EvalResultsDisplay
              questionSets={questionSets}
              userEvaluations={userEvaluations}
              evaluationDataList={evalList} />
            :
            <p>No evaluation data has been collected yet.</p>
        }
      </div>
      <ModalAlert
        show={!!alertMessage}
        message={alertMessage}
        cancel={() => setAlertMessage(null)} />
    </div>
  )
}

export default EvalDataView
